export default "__VITE_ASSET__BambKxho__"